import BlueButton from '../../components/blue-button';
import CountUp from '../../components/countup';
import {useRef} from 'react';
import {useDispatch} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {navigate} from '../../../utils/navigation';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';

export default ({index}) => {
    const dispatch = useDispatch();

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__zoomIn');
            modal.current.classList.add('animate__zoomOut');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('facebook-follow'));
            
            if(trigger === 'close')
                closePromotionModal('facebook-follow');
            else
                clickPromotionModal('facebook-follow', callback);
        }, 500);
    }
    
    return (
        <div className="action-modal-fix facebook-follow">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__zoomIn animate__faster" ref={modal}>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="facebook-follow-title">Get more bonuses<br/>on <span>Facebook</span></div>
                            <div className="facebook-follow-image"></div>
                            <BlueButton onClick={e => {
                                window.open('https://www.facebook.com/groups/1250969826568579/', '_blank')
                                closeAction('click');
                            }}>Subscribe now</BlueButton>
                            <div className="description">Follow us on Facebook and get more daily bonuses</div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}